import { Button, Modal, Form, Spinner } from 'react-bootstrap';
import { useState } from 'react';
import { FormattedMessage, useIntl, defineMessage } from 'react-intl';
import axiosInstance from '../../axiosInterceptor';
import sleep from '../../services/util/sleep';

const AddTwitterPopUp = ({ email }) => {
    const [username, setUsername] = useState(null);
    const [show, setShow] = useState(false);
    const [usernameInvalid, setUsernameInvalid] = useState(false);
    const [verifiedUser, setVerifiedUser] = useState(false);
    const [showSpinner, setShowSpinner] = useState(false);
    const [responseVariant, setResponseVariant] = useState('danger');
    const [responseMessage, setResponseMessage] = useState(null);

    const handleClose = () => setShow(false);

    const intl = useIntl();
    const messages = defineMessage({
        addMessage: {
            id: 'AddPW.successMessage',
            defaultMessage: 'Linked Twitter Successfully'
        },
        errorMessage: {
            id: 'AddPW.errorMessage',
            defaultMessage: 'Something went wrong while linking Twitter'
        }
    });

    const handleShow = () => {
        setShow(true);
        setUsername(null);
    };

    let collectData = async (username, bio) => {
        axiosInstance().post('twitter/getUserInfo', {
            username: username,
            bio: bio,
            portal: 'your-morals'
        });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setShowSpinner(true);
        try {
            const res = await axiosInstance().post(
                'twitter/addTwitterUsername',
                {
                    email: email,
                    twitterUsername: username
                }
            );

            if (res.status === 200) {
                setResponseVariant('success');
                await collectData(username, res.data.bio);
                setResponseMessage(intl.formatMessage(messages.addMessage));
                await sleep(1000);
                setShow(false);
                setUsernameInvalid(false);
                setVerifiedUser(false);
                window.location.reload();
            }
            if (res.status === 201) {
                if (res.data.message == 'Twitter Username already exists') {
                    setUsernameInvalid(true);
                }
                if (res.data.message == 'Verified User') {
                    setVerifiedUser(true);
                }
            }
        } catch (err) {
            setResponseVariant('danger');
            setResponseMessage(intl.formatMessage(messages.errorMessage));
        }
        setShowSpinner(false);
    };

    const handleInput = (e) => {
        setUsernameInvalid(false);
        setUsername(e.target.value);
    };

    return (
        <>
            <Button
                variant="outline-success"
                onClick={handleShow}
                className="w-100"
            >
                Link Twitter
            </Button>
            <Modal
                show={show}
                onHide={handleClose}
                backdrop="static"
                keyboard={false}
            >
                <Form>
                    <Modal.Header closeButton>
                        <Modal.Title className="text-success">
                            <FormattedMessage
                                id="AddTW.title"
                                defaultMessage="Add Twitter Username"
                            />
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <Form.Group controlId="formBasicEmail">
                            <Form.Label>
                                <FormattedMessage
                                    id="AddTW.twitterPrompt"
                                    defaultMessage="Please enter your Twitter username below to link to your
                            account:"
                                />
                            </Form.Label>
                            <Form.Control
                                type="text"
                                placeholder="Enter your Twitter username here"
                                onChange={handleInput}
                                isInvalid={usernameInvalid || verifiedUser}
                            />
                            <Form.Control.Feedback type="invalid">
                                {usernameInvalid && (
                                    <FormattedMessage
                                        id="AddTW.invalidUsername"
                                        defaultMessage="Twitter Username already exists."
                                    />
                                )}
                                {verifiedUser && (
                                    <FormattedMessage
                                        id="AddTW.invalidUsername"
                                        defaultMessage="Verified Twitter users cannot use this functionality."
                                    />
                                )}
                            </Form.Control.Feedback>
                            <Form.Text className="text-muted">
                                <FormattedMessage
                                    id="AddTW.notice"
                                    defaultMessage="By adding Twitter username, you can access website using Twitter SignIn"
                                />
                            </Form.Text>
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button
                            variant="outline-dark"
                            onClick={handleClose}
                            className="mr-auto"
                        >
                            <FormattedMessage
                                id="AddTW.cancel"
                                defaultMessage="Cancel"
                            />
                        </Button>
                        <Button
                            variant="outline-success"
                            onClick={handleSubmit}
                            disabled={showSpinner}
                        >
                            {showSpinner && (
                                <Spinner
                                    as="span"
                                    animation="border"
                                    size="sm"
                                    role="status"
                                    aria-hidden="true"
                                    className="mr-2"
                                />
                            )}
                            <FormattedMessage
                                id="AddTW.action"
                                defaultMessage="Link Twitter"
                            />
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>
        </>
    );
};

export default AddTwitterPopUp;
